/* Shared, idempotent initialization also supports Shopify section reloads. */
(() => {
  'use strict';
  if (window.bkV1Initialized) return;
  window.bkV1Initialized = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const arcSections = new Set();
  const visibleArcSections = new Set();
  let arcFrame = 0;
  const updateArcMotion = () => {
    arcFrame = 0;
    if (reduced.matches) {
      arcSections.forEach(section => {
        const arc = section.querySelector('.bk-arc');
        if (arc) {
          arc.style.transform = 'none';
          arc.style.willChange = '';
        }
      });
      return;
    }
    const yRange = window.innerWidth <= 749 ? -70 : -120;
    visibleArcSections.forEach(section => {
      const arc = section.querySelector('.bk-arc');
      if (!arc) return;
      const rect = section.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
      const centered = progress - 0.5;
      arc.style.transform = `translate3d(${centered * 40}px, ${centered * yRange}px, 0) rotate(${centered * 3}deg)`;
    });
  };
  const scheduleArcMotion = () => {
    if (!arcFrame) arcFrame = window.requestAnimationFrame(updateArcMotion);
  };
  const arcObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const arc = entry.target.querySelector('.bk-arc');
      if (entry.isIntersecting) {
        visibleArcSections.add(entry.target);
        if (arc && !reduced.matches) arc.style.willChange = 'transform';
      } else {
        visibleArcSections.delete(entry.target);
        if (arc) arc.style.willChange = '';
      }
    });
    scheduleArcMotion();
  });
  const initArcMotion = section => {
    if ((!section.classList.contains('bk-why') && !section.classList.contains('bk-buy')) || section.dataset.bkArcReady) return;
    section.dataset.bkArcReady = 'true';
    arcSections.add(section);
    arcObserver.observe(section);
  };
  window.addEventListener('scroll', scheduleArcMotion, { passive: true });
  window.addEventListener('resize', scheduleArcMotion, { passive: true });
  reduced.addEventListener('change', () => {
    visibleArcSections.forEach(section => {
      const arc = section.querySelector('.bk-arc');
      if (arc) arc.style.willChange = reduced.matches ? '' : 'transform';
    });
    scheduleArcMotion();
  });

  const syncForm = form => {
    const radios = [...form.querySelectorAll('input[type="radio"]')];
    const cta = form.querySelector('[data-cta-label]');
    radios.forEach(radio => {
      radio.closest('.bk-plan').classList.toggle('is-selected', radio.checked);
      if (radio.checked && cta) cta.textContent = radio.dataset.cta;
    });
  };

  const syncAllPlans = () => document.querySelectorAll('.bk-buy-form').forEach(syncForm);
  const resetHeroPills = () => document.querySelectorAll('.bk-price-pill').forEach(pill => {
    pill.classList.add('is-pill-resetting');
    pill.classList.remove('is-pill-sliding');
    void pill.offsetWidth;
    pill.classList.remove('is-pill-resetting');
  });
  const selectMonthlyAndScroll = control => {
    const buy = document.querySelector('#buy');
    if (!buy) return;
    const commit = () => {
      const monthly = buy.querySelector('.bk-buy-form input[value="monthly"]');
      if (monthly) {
        monthly.checked = true;
        syncForm(monthly.form);
        monthly.dispatchEvent(new Event('change', { bubbles: true }));
      }
      buy.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
    };
    const pill = control.classList.contains('bk-price-pill') ? control : null;
    if (pill && !reduced.matches) {
      pill.classList.remove('is-pill-sliding');
      void pill.offsetWidth;
      pill.classList.add('is-pill-sliding');
      window.setTimeout(commit, 350);
      return;
    }
    commit();
  };
  function init(root = document) {
    root.querySelectorAll('.bk').forEach(section => {
      if (section.dataset.bkReady) return;
      section.dataset.bkReady = 'true';
      initArcMotion(section);
      let timer;
      const hovered = new Set();
      const react = () => { if (!reduced.matches) section.classList.add('is-reacting'); };
      const reset = () => { if (!hovered.size || reduced.matches) section.classList.remove('is-reacting'); };
      section.querySelectorAll('.bk-btn, .bk-btn-react, .bk-plan').forEach(control => {
        control.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered.add(control); react(); } });
        control.addEventListener('pointerleave', () => { hovered.delete(control); reset(); });
        control.addEventListener('focusin', () => { react(); clearTimeout(timer); timer = setTimeout(reset, 1200); });
        control.addEventListener('focusout', reset);
        control.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse') { react(); clearTimeout(timer); timer = setTimeout(reset, 1200); }
        });
      });
      if (section.classList.contains('bk-hero')) {
        section.querySelectorAll('a[href="#buy"]').forEach(control => {
          control.addEventListener('click', event => {
            event.preventDefault();
            selectMonthlyAndScroll(control);
          });
        });
      }
      const video = section.querySelector('video');
      if (video) {
        const updateVideo = () => {
          if (reduced.matches) { video.pause(); reset(); }
          else video.play().catch(() => section.classList.add('bk-video-failed'));
        };
        video.addEventListener('error', () => section.classList.add('bk-video-failed'));
        video.addEventListener('playing', () => section.classList.remove('bk-video-failed'));
        video.querySelector('source:last-child').addEventListener('error', () => section.classList.add('bk-video-failed'));
        reduced.addEventListener('change', updateVideo);
        updateVideo();
        const retryVideo = () => { if (!reduced.matches && video.paused) video.play().catch(() => {}); };
        ['touchend', 'click', 'keydown'].forEach(type => document.addEventListener(type, retryVideo, { passive: true }));
        document.addEventListener('visibilitychange', () => { if (!document.hidden) retryVideo(); });
      }
      const form = section.querySelector('.bk-buy-form');
      if (!form) return;
      const radios = [...form.querySelectorAll('input[type="radio"]')];
      const syncPlan = () => syncForm(form);
      radios.forEach(radio => radio.addEventListener('change', syncPlan));
      syncPlan();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const selected = form.querySelector('input[type="radio"]:checked');
        const id = selected?.dataset.variant;
        const plan = selected?.dataset.sellingPlan;
        const item = { id: id ? Number(id) : null, quantity: 1 };
        if (plan) item.selling_plan = Number(plan);
        const payload = { items: [item] };
        if (form.dataset.preview === 'true') {
          console.log('Barkganic preview cart payload:', payload);
          form.dispatchEvent(new CustomEvent('bk:preview-cart', { bubbles: true, detail: payload }));
          return;
        }
        const fallback = () => { window.location.assign(form.action); };
        if (!id || selected?.dataset.available !== 'true') { fallback(); return; }
        const button = form.querySelector('.bk-cart');
        if (button.disabled) return;
        button.disabled = true;
        try {
          const base = window.Shopify?.routes?.root || '/';
          const clearResponse = await fetch(base + 'cart/clear.js', {
            method: 'POST', headers: { Accept: 'application/json' }
          });
          if (!clearResponse.ok) throw new Error('Cart clear failed');
          const response = await fetch(base + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
          });
          if (!response.ok) throw new Error('Cart add failed');
          window.location.assign(base + 'checkout');
        } catch { fallback(); }
        finally { button.disabled = false; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  window.addEventListener('pageshow', () => { syncAllPlans(); resetHeroPills(); });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
